import { View, Text, Image, TouchableOpacity } from "react-native";
import React, { useState } from "react";
import { width } from "../../imports";
import { danger, shadowSm } from "../../colors";
import MyText from "../custom/MyText";
import GalleryIcon from "../../assets/svg/GalleryIcon";
import ArticleIcon from "../../assets/svg/ArticleIcon";
import VideoTutorialIcon from "../../assets/svg/VideoTutorialIcon";
import HeartIcon from "../../assets/svg/HeartIcon";
import ShareIcon from "../../assets/svg/ShareIcon";
import { useNavigation } from "@react-navigation/native";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import { useSelector } from "react-redux";
import { currencyFormat } from "../../functions/functions";
import buyTutorial from "../../api/tutorial/buyTutorial";
import Fade from "../animation/Fade";
import { Toast } from "react-native-toast-message/lib/src/Toast";

export default function TutorialItem({
  image,
  title,
  url,
  likes,
  type,
  id,
  categoryId,
  kind,
  bought,
  store,
  setRefreshing,
}) {
  const navigation = useNavigation();
  const main = useSelector((store) => store.main);
  const currency = main.rtl ? "IR" : "US";
  const [mode, setMode] = useState(1);

  const buttonClicked = () => {
    if (main.token === null) {
      Toast.show({
        type: "error",
        text1: translate("please login first"),
      });
      return;
    }
    if (mode === 1) {
      setMode(2);
    } else {
      buyTutorial(store.id, currency).then(({ data }) => {
        if (data.status === 106) {
          dispatch(setNoMoneyModal());
        } else if (data.status === 200) {
          setRefreshing((prev) => !prev);
          navigation.navigate("Tutorial", {
            id: id,
            category: title,
            categoryId: categoryId,
          });
        } else {
          Toast.show({
            type: "error",
            text1: main.rtl ? data.description.fa : data.description.en,
          });
        }
      });
      setMode(1);
    }
  };

  return (
    <TouchableOpacity
      activeOpacity={1}
      onPress={() => {
        navigation.navigate("Tutorial", {
          id: id,
          category: title,
          categoryId: categoryId,
        });
      }}
      style={{
        width: width / 2.3,
        height: width / 1.5,
        margin: 10,
        ...shadowSm,
        padding: 10,
        alignItems: "center",
        borderRadius: 15,
      }}
    >
      <View>
        <Image
          source={{ uri: image }}
          style={{ width: width / 2.6, height: width / 2.6 }}
          resizeMode="contain"
        />
      </View>
      <MyText style={{ marginTop: 5, fontSize: 11 }}>{title}</MyText>
      <View style={{ flex: 1 }}></View>
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <View>
          {type === "video" ? <VideoTutorialIcon /> : <ArticleIcon />}
        </View>
        <View style={{ flex: 1 }}></View>
        {/* <View style={{ marginHorizontal: 1 }}>
          <ShareIcon />
        </View> */}
        <View style={{ marginHorizontal: 1 }}>
          <HeartIcon />
        </View>
        <MyText
          style={{ marginHorizontal: 4, fontSize: 10 }}
        >{`${likes}`}</MyText>
      </View>
      <View
        style={{
          height: 45,
          justifyContent: "center",
          alignItems: "center",
          paddingTop: 5,
          width: "100%",
        }}
      >
        {kind !== "monetary" && (
          <MyText style={{ fontSize: 14 }}>{translate("free")}</MyText>
        )}
        {kind === "monetary" && !bought && (
          <View style={{ justifyContent: "center", alignItems: "center" }}>
            <Fade isShown={mode === 1} duration={200}>
              <MyButton
                onPress={buttonClicked}
                text={`${
                  main.rtl
                    ? currencyFormat(
                        store.priceOffer !== 0 ? store.priceOffer : store.price
                      )
                    : store.priceOfferEn !== 0
                    ? store.priceOfferEn
                    : store.priceEn
                } ${translate("currency")}`}
              />
            </Fade>
            <Fade isShown={mode === 2} duration={200}>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <View style={{ flex: 2 }}>
                  <MyButton
                    textStyle={{ fontSize: 12 }}
                    onPress={() => setMode(1)}
                    style={{
                      backgroundColor: danger,
                      paddingHorizontal: 0,
                      marginHorizontal: 2,
                    }}
                    text={`${translate("cancel")}`}
                  />
                </View>
                <View style={{ flex: 4 }}>
                  <MyButton
                    textStyle={{ fontSize: 13 }}
                    style={{ paddingHorizontal: 0, marginHorizontal: 2 }}
                    onPress={buttonClicked}
                    text={`${translate("accept")}`}
                  />
                </View>
              </View>
            </Fade>
          </View>
        )}
        {kind === "monetary" && bought && (
          <View>
            <MyText style={{ fontSize: 14 }}>{translate("bought")}</MyText>
          </View>
        )}
      </View>
    </TouchableOpacity>
  );
}
